export default __webpack_public_path__ + "static/media/tv.25525747.svg";